export default __webpack_public_path__ + "static/07_responsive_support-a4d885cc08841812ed20a00cbfb1316d.png";